module.exports = __webpack_public_path__ + "img/ico-scrap-white-active.63997a89.svg";